import { render, staticRenderFns } from "./NumberField.dynamic.vue?vue&type=template&id=12006fa0&"
import script from "./NumberField.dynamic.vue?vue&type=script&lang=js&"
export * from "./NumberField.dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports